export const navLinksEn = [
  { label: "Product", href: "#producto" },
  { label: "Pricing", href: "#precios" },
  { label: "Integrations", href: "#integraciones" },
  { label: "Dashboard", href: "#dashboard" },
];

export const problemStatsEn = [
  { value: "67%", label: "of missed calls never call back", icon: "ri-phone-off-line" },
  { value: "80%", label: "cost reduction vs traditional call center", icon: "ri-bar-chart-line" },
  { value: "3 min", label: "setup time to launch your AI receptionist", icon: "ri-timer-flash-line" },
  { value: "24/7", label: "total availability, no holidays or vacation", icon: "ri-time-line" },
];

export const featuresEn = [
  {
    icon: "ri-shield-check-line",
    title: "Total 24/7/365 Availability",
    description: "Absolute elimination of missed calls. Your AI receptionist captures leads at the exact moment of purchase intent, even at 3 AM.",
    metric: "0",
    metricLabel: "missed calls",
    color: "amber",
  },
  {
    icon: "ri-money-dollar-circle-line",
    title: "Radical Cost Reduction",
    description: "Replace fixed costs with an elastic model. Reduce operational load by 80% compared to a traditional call center without sacrificing quality.",
    metric: "80%",
    metricLabel: "operational savings",
    color: "emerald",
  },
  {
    icon: "ri-global-line",
    title: "Native Multilingual Capability",
    description: "Fluent service in over 31 languages with automatic detection. Immediate global expansion without hiring native staff in each market.",
    metric: "31",
    metricLabel: "native languages",
    color: "amber",
  },
];

export const testimonialsEn = [
  {
    id: 1,
    name: "Dr. Alejandro Martínez",
    role: "Medical Director",
    company: "Advanced Health Clinic",
    avatar: "https://public.readdy.ai/ai/img_res/fc7213a085e698c440b4b000570bc2b8.jpg",
    quote: "Since we implemented VoiceAI, we have never missed an appointment. The ROI was visible in the first week. Our team can now focus on what really matters.",
    rating: 5,
    platform: "G2",
    metrics: "+240% leads captured",
  },
  {
    id: 2,
    name: "María González",
    role: "Founding Partner",
    company: "González & Associates",
    avatar: "https://readdy.ai/api/search-image?query=professional%20female%20lawyer%20headshot%2C%20confident%20expression%2C%20office%20background%2C%20premium%20portrait%20photography%2C%20natural%20lighting%2C%20elegant%20appearance&width=80&height=80&seq=t2&orientation=squarish",
    quote: "In a law firm, every missed call is a lost client. VoiceAI handles the first contact with a precision and professionalism that surprised us.",
    rating: 5,
    platform: "Capterra",
    metrics: "0 missed calls in 6 months",
  },
  {
    id: 3,
    name: "Carlos Ruiz",
    role: "CEO",
    company: "TechService Pro",
    avatar: "https://readdy.ai/api/search-image?query=professional%20male%20tech%20executive%20headshot%2C%20modern%20office%20background%2C%20business%20casual%2C%20contemporary%20portrait%20photography%2C%20confident%20leadership%20look&width=80&height=80&seq=t3&orientation=squarish",
    quote: "The Google Calendar integration was instant. Now the system schedules, reschedules and confirms appointments autonomously. We haven't touched a thing.",
    rating: 5,
    platform: "G2",
    metrics: "70% staff reduction",
  },
  {
    id: 4,
    name: "Ana Fernández",
    role: "Director of Operations",
    company: "Dental Excellence",
    avatar: "https://readdy.ai/api/search-image?query=professional%20female%20operations%20director%20headshot%2C%20modern%20dental%20clinic%20background%2C%20business%20attire%2C%20high%20quality%20portrait%2C%20warm%20approachable%20smile&width=80&height=80&seq=t4&orientation=squarish",
    quote: "We needed service in Catalan, Spanish and English. VoiceAI detects it automatically and switches language without any friction. It's technological magic.",
    rating: 5,
    platform: "Capterra",
    metrics: "3 simultaneous languages",
  },
];

export const liveMetricsEn = [
  { value: "2.4M+", label: "Calls managed this month" },
  { value: "99.7%", label: "Guaranteed uptime SLA" },
  { value: "14s", label: "Average response time" },
  { value: "4.9/5", label: "Average end-user satisfaction" },
];

export const pricingPlansEn = [
  {
    id: "basico",
    name: "Basic",
    price: "199",
    period: "mo",
    description: "Ideal for small businesses starting their digitalization",
    highlighted: false,
    cta: "Start Now",
    features: [
      { text: "500 voice minutes per month", included: true },
      { text: "Standard phone number", included: true },
      { text: "Basic Google Calendar integration", included: true },
      { text: "Standard security", included: true },
      { text: "Email support 5×8", included: true },
      { text: "1 configured language", included: true },
      { text: "Automatic PII Redaction", included: false },
      { text: "Full Multi-Calendar", included: false },
      { text: "HIPAA/Enterprise compliance", included: false },
      { text: "FastMCP / Custom CRM", included: false },
    ],
  },
  {
    id: "profesional",
    name: "Professional",
    price: "399",
    period: "mo",
    description: "The favorite plan for clinics and offices with high volume",
    highlighted: true,
    badge: "MOST POPULAR",
    cta: "Start Now",
    features: [
      { text: "1,500 voice minutes per month", included: true },
      { text: "Verified Caller ID", included: true },
      { text: "Full Multi-Calendar", included: true },
      { text: "Automatic PII Redaction", included: true },
      { text: "Priority 24/7 support", included: true },
      { text: "Up to 10 configured languages", included: true },
      { text: "Canvas Memory (Real-time RAG)", included: true },
      { text: "HIPAA/Enterprise compliance", included: false },
      { text: "FastMCP / Custom CRM", included: false },
      { text: "Branded Call ID", included: false },
    ],
  },
  {
    id: "premium",
    name: "Premium",
    price: "799",
    period: "mo",
    description: "For enterprise companies with maximum scale needs",
    highlighted: false,
    cta: "Start Now",
    features: [
      { text: "Unlimited minutes", included: true },
      { text: "Corporate Branded Call ID", included: true },
      { text: "FastMCP / Custom CRM", included: true },
      { text: "HIPAA/Enterprise compliance", included: true },
      { text: "Dedicated SLA 99.9% support", included: true },
      { text: "31 full native languages", included: true },
      { text: "Canvas Memory (Real-time RAG)", included: true },
      { text: "Full API access", included: true },
      { text: "Personalized onboarding", included: true },
      { text: "Dedicated infrastructure", included: true },
    ],
  },
];

export const integrationsEn = [
  { name: "Google Calendar", icon: "ri-calendar-check-line", category: "Scheduling" },
  { name: "Stripe", icon: "ri-bank-card-line", category: "Payments" },
  { name: "HubSpot", icon: "ri-contacts-line", category: "CRM" },
  { name: "Salesforce", icon: "ri-cloud-line", category: "CRM" },
  { name: "Slack", icon: "ri-slack-line", category: "Communication" },
  { name: "Zapier", icon: "ri-flashlight-line", category: "Automation" },
  { name: "Microsoft Teams", icon: "ri-team-line", category: "Communication" },
  { name: "Twilio", icon: "ri-phone-line", category: "Telephony" },
  { name: "WhatsApp", icon: "ri-whatsapp-line", category: "Messaging" },
  { name: "Zoho CRM", icon: "ri-briefcase-line", category: "CRM" },
  { name: "Notion", icon: "ri-file-list-line", category: "Productivity" },
  { name: "Webhooks API", icon: "ri-code-s-slash-line", category: "Development" },
];

export const securityFeaturesEn = [
  { icon: "ri-shield-keyhole-line", title: "HIPAA Compliance", desc: "Medical data protected under the highest international standards" },
  { icon: "ri-lock-password-line", title: "Automatic PII Redaction", desc: "Automatic removal of sensitive personal data in transcripts" },
  { icon: "ri-server-line", title: "ISO 27001 Infrastructure", desc: "Europe-certified servers with AES-256 encryption at rest and in transit" },
  { icon: "ri-eye-off-line", title: "Zero-Knowledge Architecture", desc: "Not even our team can access your customers' conversations" },
];

export const dashboardStatsEn = [
  { label: "Calls Answered", value: "1,847", change: "+12%", icon: "ri-phone-fill", positive: true },
  { label: "Leads Captured", value: "342", change: "+28%", icon: "ri-user-add-fill", positive: true },
  { label: "Appointments Scheduled", value: "218", change: "+19%", icon: "ri-calendar-fill", positive: true },
  { label: "Cost per Lead", value: "€4.20", change: "-31%", icon: "ri-money-euro-circle-fill", positive: true },
];

export const recentCallsEn = [
  { time: "Today 14:32", caller: "+34 612 345 678", duration: "3:24", outcome: "Appointment scheduled", lang: "ES" },
  { time: "Today 13:15", caller: "+44 7700 900123", duration: "1:52", outcome: "Lead captured", lang: "EN" },
  { time: "Today 11:48", caller: "+34 699 112 233", duration: "4:07", outcome: "Appointment scheduled", lang: "ES" },
  { time: "Today 10:23", caller: "+33 6 12 34 56 78", duration: "2:31", outcome: "Information sent", lang: "FR" },
  { time: "Yesterday 18:55", caller: "+34 608 765 432", duration: "1:15", outcome: "VIP transfer", lang: "ES" },
];

export const tbcspnLayersEn = [
  {
    id: "surface",
    label: "Surface Layer",
    sublabel: "Surface Layer",
    color: "amber",
    icon: "ri-user-star-line",
    role: "Centauric AI — Human Supervision",
    description: "The client defines strategic direction and validates critical business decisions. Full control without technical complexity.",
    agents: ["Client / Operator", "Decision Validation", "Control Panel"],
  },
  {
    id: "observation",
    label: "Observation Layer",
    sublabel: "Observation Layer",
    color: "stone",
    icon: "ri-search-eye-line",
    role: "planning_agent — Orchestration",
    description: "Refines topics and orchestrates the conversation by analyzing full history before activating the execution layer.",
    agents: ["planning_agent", "History Analysis", "Topic Refinement"],
  },
  {
    id: "computation",
    label: "Computation Layer",
    sublabel: "Computation Layer",
    color: "emerald",
    icon: "ri-cpu-line",
    role: "worker_agents — Execution",
    description: "Executing agents handle the call, process natural language and run calendar APIs in real time.",
    agents: ["interviewer_agent", "calendar_agent", "CRM API Connector"],
  },
];

export const techStackEn = [
  { category: "Frontend & Backend", icon: "ri-code-box-line", items: ["Next.js 14 (Server Components)", "TailwindCSS + shadcn/ui", "Neon PostgreSQL + Prisma ORM"] },
  { category: "AI Orchestration", icon: "ri-robot-line", items: ["AutoGen Multi-Agent Framework", "MCP (Model Context Protocol)", "TB-CSPN Process Networks"] },
  { category: "Memory & RAG", icon: "ri-database-2-line", items: ["ChromaDB Semantic", "Contextual Episodic Memory", "Real-time RAG"] },
  { category: "Voice & Telephony", icon: "ri-phone-line", items: ["OpenAI Realtime API", "Twilio Media Streams", "Modular WebSocket Bridge"] },
];

export const voiceLatencyStepsEn = [
  { step: "01", label: "Audio Input", desc: "Twilio captures incoming call audio in real time", icon: "ri-mic-line", ms: "0ms" },
  { step: "02", label: "Media Stream", desc: "Twilio Media Streams transmits audio via WebSocket to the bridge", icon: "ri-broadcast-line", ms: "~50ms" },
  { step: "03", label: "Realtime API", desc: "OpenAI Realtime API processes audio-to-audio natively", icon: "ri-brain-line", ms: "~200ms" },
  { step: "04", label: "LLM + Agents", desc: "planning_agent orchestrates the response with RAG context", icon: "ri-flashlight-line", ms: "~350ms" },
  { step: "05", label: "Audio Output", desc: "Synthesized response sent to the end user", icon: "ri-volume-up-line", ms: "&lt;1s total" },
];

export const callerIdFeaturesEn = [
  { icon: "ri-shield-check-line", title: "Verified SHAKEN/STIR", desc: "Cryptographic signature certifying number authenticity to carriers" },
  { icon: "ri-building-line", title: "Branded Caller ID", desc: "Your company name appears on the client's screen, increasing answer rates by up to 40%" },
  { icon: "ri-spam-2-line", title: "Anti-SPAM Engine", desc: "Active number reputation system to prevent being flagged as SPAM by carriers" },
];

export const securityProtocolsEn = [
  { icon: "ri-token-swap-line", title: "JWT Authentication", desc: "Short-expiry tokens with refresh rotation to protect every dashboard session" },
  { icon: "ri-eraser-line", title: "PII Redaction Engine", desc: "Automatically identifies and removes names, IDs, IBANs and sensitive data from transcripts before storage" },
  { icon: "ri-stethoscope-line", title: "HIPAA Compliant", desc: "Business Associate Agreement (BAA) available for clinics and healthcare providers on Premium plan" },
  { icon: "ri-file-shield-2-line", title: "GDPR", desc: "Data residency in Europe (Frankfurt). Automated right to erasure. DPA signed at onboarding" },
];

export const learningCycleEn = [
  { phase: "Build", icon: "ri-hammer-line", desc: "Canvas Memory defines the agent's base knowledge for your specific business" },
  { phase: "Collaborate", icon: "ri-team-line", desc: "The agent handles real calls and generates Episodic Memories from each interaction" },
  { phase: "Evolve", icon: "ri-plant-line", desc: "Validated successful calls are automatically transferred to the main RAG, continuously improving the system" },
];

export const howItWorksStepsEn = [
  {
    number: "01",
    title: "The client calls",
    subtitle: "Incoming call detected",
    description: "Your corporate phone number automatically routes to the AI. The call is answered on the first ring, no wait, any day of the year at any time.",
    icon: "ri-phone-incoming-line",
    details: [
      "Instant first-ring response",
      "Verified and logged Caller ID",
      "Language detected automatically",
      "Client context loaded from CRM",
    ],
    visual: "phone",
  },
  {
    number: "02",
    title: "The AI converses and understands",
    subtitle: "Real-time processing",
    description: "The agent converses naturally, identifies the client's intent, queries your knowledge base in real time and handles any request with precision.",
    icon: "ri-robot-2-line",
    details: [
      "Deep semantic understanding",
      "Query to your business RAG",
      "Urgency and VIP detection",
      "Guaranteed sub-second latency",
    ],
    visual: "ai",
  },
  {
    number: "03",
    title: "The appointment is booked",
    subtitle: "Automatic confirmation",
    description: "The agent checks availability in real time, proposes the optimal slot under ISO 8601, confirms the appointment and sends automatic reminders. You touch nothing.",
    icon: "ri-calendar-check-2-line",
    details: [
      "FastMCP availability verification",
      "Event created in Google Calendar",
      "SMS and email confirmation",
      "Autonomous rescheduling if conflict",
    ],
    visual: "calendar",
  },
];

export const faqItemsEn = [
  {
    id: "f1",
    category: "Technology",
    question: "Does the voice sound artificial or robotic? Can customers tell?",
    answer: "Naturalness is our number one technical priority. We use OpenAI Realtime API with next-generation voice synthesis that achieves prosody, rhythm and emotion virtually indistinguishable from a real person. In our A/B tests with over 10,000 calls, 94% of end users did not detect they were talking to an AI. Premium clients can choose from additional voice engines like ElevenLabs to further customize tone and accent.",
  },
  {
    id: "f2",
    category: "Privacy",
    question: "What happens to my customers' data? Is it secure?",
    answer: "Data security is our cornerstone. All data is stored exclusively on European servers (Frankfurt, EU-CENTRAL-1) with AES-256 encryption at rest and TLS 1.3 in transit. Our PII Redaction engine automatically removes names, IDs and sensitive data from transcripts before storing them. We are HIPAA Compliant, GDPR certified and have ISO 27001 accreditation. We never sell or share data with third parties.",
  },
  {
    id: "f3",
    category: "Setup",
    question: "How is it configured? Do I need technical knowledge or an IT team?",
    answer: "Zero technical knowledge required. The full configuration is done in less than 3 minutes through our visual control panel. You only need: (1) connect your Google Calendar with one click, (2) write in Canvas Memory what your AI should know about your business (hours, services, prices), and (3) redirect your phone number. No code, no complex APIs, no 200-page manuals. If you know how to use WhatsApp, you know how to configure VoiceAI.",
  },
  {
    id: "f4",
    category: "Technology",
    question: "What happens if the AI doesn't know how to answer a specific question?",
    answer: "When the agent detects it doesn't have enough context to answer confidently, it automatically activates the intelligent escalation protocol: transfers the call to a team member with a contextual summary prior to handoff. You define the rules: what type of questions escalate, to which number, at what hours. Additionally, every time this occurs, the system logs it as a learning opportunity and notifies you to add that information to Canvas Memory, continuously improving the system.",
  },
  {
    id: "f5",
    category: "Compatibility",
    question: "Does it work in my sector? Is it valid for clinics, law firms or technical companies?",
    answer: "VoiceAI is designed specifically for high-demand sectors: medical and dental clinics, law firms, consultancies, technical and maintenance services, training centers and any SME with high inbound call volume. Professional and Premium plans include sector-specific pre-trained configurations, including specialized vocabulary, medical emergency protocols and legal triage flows.",
  },
  {
    id: "f6",
    category: "Business",
    question: "Can I cancel whenever I want? Are there long-term contracts?",
    answer: "No contracts. No lock-in. No fine print. You can cancel your plan from the dashboard at any time with one click and your account will remain active until the end of the already-paid billing period. No penalties, no uncomfortable retention calls. We believe that if our platform doesn't generate value for your business, we don't deserve your money.",
  },
  {
    id: "f7",
    category: "Implementation",
    question: "How long does it take to get the AI operational after signing up?",
    answer: "Under normal conditions, your AI receptionist can be answering real calls in less than 15 minutes from registration. The flow is: registration → connect Google Calendar (2 min) → write Canvas Memory with your business info (5-10 min) → set up call forwarding from your carrier (2 min). For Premium clients with custom CRM integrations or complex flows, the dedicated onboarding takes 24-48 hours with our team's guidance.",
  },
  {
    id: "f8",
    category: "Integrations",
    question: "Does it integrate with my current management system or CRM?",
    answer: "Yes, thanks to the MCP (Model Context Protocol), we can connect to virtually any system. Native integrations include Google Calendar, HubSpot, Salesforce, Zoho CRM, Microsoft Teams, Slack and Zapier (which in turn connects to over 5,000 applications). For proprietary systems or sector-specific ERPs, Premium plans include custom integrations through our documented REST API.",
  },
];
